
import RegisterTestComponent from "@/views/Covid/RegisterTest/RegisterTestComponent";
export default RegisterTestComponent;
